import request from "@/config/utils/request";

// 编辑
export function postEditDemoUser(data) {
  return request({
    url: "/apis/demo/demouser/editDemoUser",
    method: "POST",
    data
  });
}
// 添加
export function postAddDemoUser(data) {
  return request({
    url: "/apis/demo/demouser/saveDemoUser",
    method: "POST",
    data
  });
}
// 删除
export function postDeleteDemoUser(data) {
  return request({
    url: "/apis/demo/demouser/removeDemoUser", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function postGetDetail(data) {
  return request({
    url: "/apis/demo/demouser/getDemoUserById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function postGetList(data) {
  return request({
    url: "/apis/demo/demouser/listDemoUserPage",
    method: "POST",
    data
  });
}
